import React from "react";
import {
  Device,
  hasEndpointStatistics,
  Statistics,
} from "@services/devices/types";
import ListView from "@common/components/ListDetailViews/ListView";
import { findEndpointStatistic } from "../const";

type Data = {
  label: string;
  up: number;
  down: number;
};

const dataFromStatistics = (statistics: Statistics): Data[] => {
  const content = [
    {
      label: "Lost Media Packets",
      up: statistics.callStats?.totalPacketLossTx ?? 0,
      down: statistics.callStats?.totalPacketLossRx ?? 0,
    },
    {
      label: "Media Packet Loss (%)",
      up: statistics.callStats?.percentPacketLossTx ?? 0,
      down: statistics.callStats?.percentPacketLossRx ?? 0,
    },
    {
      label: "Video Jitter (ms)",
      up: statistics.videoChannelStats?.jitterTx ?? 0,
      down: statistics.videoChannelStats?.jitterRx ?? 0,
    },
    {
      label: "Audio Jitter (ms)",
      up: statistics.audioChannelStats?.jitterTx ?? 0,
      down: statistics.audioChannelStats?.jitterRx ?? 0,
    },
  ];
  if (Object.keys(statistics.contentChannelStats ?? {}).length > 0) {
    content.splice(1, 0, {
      label: "Lost Content Packets",
      up: statistics.contentChannelStats?.packetLossTx ?? 0,
      down: statistics.contentChannelStats?.packetLossRx ?? 0,
    });

    content.splice(3, 0, {
      label: "Content Packet Loss (%)",
      up: statistics.contentChannelStats?.percentPacketLossTx ?? 0,
      down: statistics.contentChannelStats?.percentPacketLossRx ?? 0,
    });

    content.push({
      label: "Content Jitter (ms)",
      up: statistics.contentChannelStats?.jitterTx ?? 0,
      down: statistics.contentChannelStats?.jitterRx ?? 0,
    });
  }
  return content;
};

const colDefs: ColDef<Data>[] = [
  {
    key: "label",
    label: "",
    sortable: false,
  },
  {
    key: "up",
    label: "Sending",
    sortable: false,
  },
  {
    key: "down",
    label: "Receiving",
    sortable: false,
  },
];
const List = ({ statistics }: { statistics: Statistics }) => (
  <ListView
    columns={colDefs}
    data={dataFromStatistics(statistics)}
    pinFirstColumn
    disableColumnResize
    sx={{
      height: "fit-content",
      "& > div": {
        overflow: "hidden",
      },
      "& table": {
        width: "100%",
        tableLayout: "fixed",
      },
      "& thead > tr > th": {
        borderTop: "none",
        width: "auto!important",
        minWidth: "auto!important",
      },
      "& thead > tr > th:first-of-type": {
        width: "130px!important",
        minWidth: "130px!important",
      },
    }}
  />
);
export const ListFromDevice = ({ device }: { device?: Device }) => {
  let stat: Statistics | undefined;
  if (hasEndpointStatistics(device)) stat = findEndpointStatistic(device);
  return stat === undefined ? <></> : <List statistics={stat} />;
};

export default ListFromDevice;
